import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import * as authAction from "../Store/_redux/AuthStore/authActions";

export default function Settings() {
  const dispatch = useDispatch();
  const [enabled, setEnabled] = useState(true);
  const [days, setDays] = useState(1);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    dispatch(authAction.getSettingsAction()).then((res) => {
      if (res) {
        setEnabled(res.birthdayNotificationsEnabled);
        setDays(res.birthdayNotificationDaysBefore);
      }
      setLoading(false);
    });
  }, [dispatch]);

  const handleSave = (e) => {
    e.preventDefault();
    setSaving(true);
    dispatch(
      authAction.updateSettingsAction({
        birthdayNotificationsEnabled: enabled,
        birthdayNotificationDaysBefore: Number(days),
      })
    ).then((res) => {
      setSaving(false);
      if (res) {
        toast.success("Ayarlar başarıyla güncellendi!");
      } else {
        toast.error("Ayarlar kaydedilerken bir hata oluştu.");
      }
    });
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-3xl font-semibold mb-6">Sistem Ayarları</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-medium mb-4 pb-2 border-b">Doğum Günü Bildirim Ayarları</h2>
        <form onSubmit={handleSave} className="space-y-6">
          
          {/* Bildirim Aç/Kapat Toggle */}
          <div className="flex items-center justify-between">
            <div>
              <label className="font-semibold text-gray-700 block">Doğum Günü Bildirimleri</label>
              <span className="text-sm text-gray-500">Çalışanların yaklaşan doğum günleri hakkında bildirim gönderilsin mi?</span>
            </div>
            <input
              type="checkbox"
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
              className="w-11 h-6 bg-gray-200 rounded-full appearance-none cursor-pointer checked:bg-blue-600 relative after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all checked:after:translate-x-5"
            />
          </div>

          {/* Gün Seçimi */}
          {enabled && (
            <div className="space-y-2">
              <label className="font-semibold text-gray-700 block">Bildirim Süresi (Gün Önceden)</label>
              <input
                type="number"
                min="0"
                max="30"
                value={days}
                onChange={(e) => setDays(e.target.value)}
                className="border rounded-md px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                placeholder="Örn: 7"
              />
              <span className="text-xs text-gray-400">Doğum gününe kaç gün kala bildirim oluşturulacağını belirtin.</span>
            </div>
          )}

          {/* Kaydet Butonu */}
          <div className="flex justify-end pt-4">
            <button
              type="submit"
              disabled={saving}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2.5 rounded-lg transition-colors duration-200"
            >
              {saving ? "Kaydediliyor..." : "Ayarları Kaydet"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
